import { SectionContentAnswer } from "./SectionContentAnswer";

export default SectionContentAnswer;